var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacedonateImg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 1374.268,
    height: 626.164,
    viewBox: "0, 0, 1374.268, 626.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(-11987.414, -2917.583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13140.432,3183.375 C13140.432,3219.633 13111.039,3249.025 13074.782,3249.025 C13038.524,3249.025 13009.132,3219.633 13009.132,3183.375 C13009.132,3147.118 13038.524,3117.726 13074.782,3117.726 C13111.039,3117.726 13140.432,3147.118 13140.432,3183.375 z",
    fill: "#FF6584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13047.426,3445.845 L13049.843,3445.845 L13049.843,3541.33 L13047.426,3541.33 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13072.152,3458.013 C13072.307,3491.402 13048.815,3518.578 13048.815,3518.578 C13048.815,3518.578 13025.075,3491.62 13024.921,3458.231 C13024.768,3424.842 13048.258,3397.666 13048.258,3397.666 C13048.258,3397.666 13071.998,3424.624 13072.152,3458.013 z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13072.152,3458.013 C13072.307,3491.402 13048.815,3518.578 13048.815,3518.578 C13048.815,3518.578 13025.075,3491.62 13024.921,3458.231 C13024.768,3424.842 13048.258,3397.666 13048.258,3397.666 C13048.258,3397.666 13071.998,3424.624 13072.152,3458.013 z",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12630.757,3218.233 C12630.757,3239.092 12613.848,3256.001 12592.988,3256.001 C12572.129,3256.001 12555.22,3239.092 12555.22,3218.233 C12555.22,3197.374 12572.129,3180.464 12592.988,3180.464 C12613.848,3180.464 12630.757,3197.374 12630.757,3218.233 z",
    fill: "#6C63FF",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12549.582,3236.271 C12549.582,3250.904 12537.721,3262.766 12523.088,3262.766 C12508.455,3262.766 12496.594,3250.904 12496.594,3236.271 C12496.594,3221.639 12508.455,3209.777 12523.088,3209.777 C12537.721,3209.777 12549.582,3221.639 12549.582,3236.271 z",
    fill: "#6C63FF",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12265.543,3312.418 C12265.543,3327.051 12253.681,3338.913 12239.048,3338.913 C12224.416,3338.913 12212.554,3327.051 12212.554,3312.418 C12212.554,3297.786 12224.416,3285.924 12239.048,3285.924 C12253.681,3285.924 12265.543,3297.786 12265.543,3312.418 z",
    fill: "#6C63FF",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13060.189,3215.125 C13060.189,3235.985 13043.279,3252.894 13022.42,3252.894 C13001.562,3252.894 12984.651,3235.985 12984.651,3215.125 C12984.651,3194.266 13001.562,3177.357 13022.42,3177.357 C13043.279,3177.357 13060.189,3194.266 13060.189,3215.125 z",
    fill: "#6C63FF",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12055.861,3530.713 C12057.909,3538.282 12064.922,3542.969 12064.922,3542.969 C12064.922,3542.969 12068.615,3535.385 12066.568,3527.817 C12064.521,3520.248 12057.508,3515.561 12057.508,3515.561 C12057.508,3515.561 12053.814,3523.145 12055.861,3530.713 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12058.87,3529.086 C12064.488,3534.556 12065.175,3542.963 12065.175,3542.963 C12065.175,3542.963 12056.752,3542.503 12051.134,3537.034 C12045.516,3531.565 12044.829,3523.157 12044.829,3523.157 C12044.829,3523.157 12053.252,3523.617 12058.87,3529.086 z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12795.573,3530.713 C12797.621,3538.282 12804.634,3542.969 12804.634,3542.969 C12804.634,3542.969 12808.327,3535.385 12806.28,3527.817 C12804.232,3520.248 12797.22,3515.561 12797.22,3515.561 C12797.22,3515.561 12793.526,3523.145 12795.573,3530.713 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12798.582,3529.086 C12804.2,3534.556 12804.887,3542.963 12804.887,3542.963 C12804.887,3542.963 12796.464,3542.503 12790.846,3537.034 C12785.228,3531.565 12784.541,3523.157 12784.541,3523.157 C12784.541,3523.157 12792.964,3523.617 12798.582,3529.086 z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12069.77,3473.821 L12064.77,3465.487 L12111.441,3425.482 L12231.456,3425.482 L12231.456,3437.15 L12188.117,3483.823 L12138.11,3493.824 L12069.77,3473.821 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12252.114,3448.959 L12252.114,3422.879 L12236.401,3422.879 L12236.401,3431.103 L12231.456,3425.482 L12191.451,3465.487 L12184.782,3472.155 L12176.448,3505.492 L12191.451,3542.162 L12268.126,3542.162 L12268.126,3467.154 L12252.114,3448.959 z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12064.77,3465.487 L12191.45,3465.487 L12191.45,3542.163 L12064.77,3542.163 z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12147.278,3489.656 L12173.948,3489.656 L12173.948,3512.992 L12147.278,3512.992 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12113.108,3488.823 L12136.444,3488.823 L12136.444,3542.163 L12113.108,3542.163 z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12086.438,3497.157 L12086.438,3488.823 L12076.438,3488.823 L12076.438,3497.157 L12085.604,3497.157 L12086.438,3497.157 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12085.604,3503.824 L12076.438,3503.824 L12076.438,3512.159 L12086.438,3512.159 L12086.438,3503.824 L12085.604,3503.824 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12093.105,3488.823 L12103.106,3488.823 L12103.106,3497.157 L12093.105,3497.157 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12093.105,3503.825 L12103.106,3503.825 L12103.106,3512.159 L12093.105,3512.159 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12227.288,3497.991 L12227.288,3489.656 L12217.286,3489.656 L12217.286,3497.991 L12226.454,3497.991 L12227.288,3497.991 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12226.454,3504.658 L12217.286,3504.658 L12217.286,3512.992 L12227.288,3512.992 L12227.288,3504.658 L12226.454,3504.658 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12233.955,3489.656 L12243.957,3489.656 L12243.957,3497.991 L12233.955,3497.991 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12233.955,3504.658 L12243.957,3504.658 L12243.957,3512.992 L12233.955,3512.992 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12552.032,3473.821 L12547.032,3465.487 L12593.704,3425.482 L12713.719,3425.482 L12713.719,3437.15 L12670.38,3483.823 L12620.374,3493.824 L12552.032,3473.821 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12734.378,3448.959 L12734.378,3422.879 L12718.665,3422.879 L12718.665,3431.103 L12713.719,3425.482 L12673.714,3465.487 L12667.046,3472.155 L12658.712,3505.492 L12673.714,3542.162 L12750.389,3542.162 L12750.389,3467.154 L12734.378,3448.959 z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12547.032,3465.487 L12673.714,3465.487 L12673.714,3542.163 L12547.032,3542.163 z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12629.542,3489.656 L12656.212,3489.656 L12656.212,3512.992 L12629.542,3512.992 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12595.371,3488.823 L12618.707,3488.823 L12618.707,3542.163 L12595.371,3542.163 z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12568.701,3497.157 L12568.701,3488.823 L12558.701,3488.823 L12558.701,3497.157 L12567.867,3497.157 L12568.701,3497.157 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12567.867,3503.824 L12558.701,3503.824 L12558.701,3512.159 L12568.701,3512.159 L12568.701,3503.824 L12567.867,3503.824 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12575.369,3488.823 L12585.37,3488.823 L12585.37,3497.157 L12575.369,3497.157 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12575.369,3503.825 L12585.37,3503.825 L12585.37,3512.159 L12575.369,3512.159 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12709.551,3497.991 L12709.551,3489.656 L12699.55,3489.656 L12699.55,3497.991 L12708.717,3497.991 L12709.551,3497.991 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12708.717,3504.658 L12699.55,3504.658 L12699.55,3512.992 L12709.551,3512.992 L12709.551,3504.658 L12708.717,3504.658 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12716.219,3489.656 L12726.22,3489.656 L12726.22,3497.991 L12716.219,3497.991 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12716.219,3504.658 L12726.22,3504.658 L12726.22,3512.992 L12716.219,3512.992 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12326.466,3333.805 L12318.133,3327.137 L12364.805,3285.465 L12483.151,3285.465 L12483.151,3322.137 L12406.476,3373.81 L12326.466,3333.805 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12504.729,3308.841 L12504.729,3286.298 L12489.016,3286.298 L12489.016,3291.82 L12483.151,3285.466 L12444.812,3327.137 L12429.812,3337.139 L12406.551,3507.083 L12441.631,3542.162 L12523.156,3542.162 L12523.156,3328.804 L12504.729,3308.841 z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12318.132,3327.137 L12444.813,3327.137 L12444.813,3542.163 L12318.132,3542.163 z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12367.305,3489.656 L12390.641,3489.656 L12390.641,3542.163 L12367.305,3542.163 z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12342.301,3504.658 L12342.301,3496.324 L12332.301,3496.324 L12332.301,3504.658 L12341.469,3504.658 L12342.301,3504.658 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12341.469,3511.325 L12332.301,3511.325 L12332.301,3519.66 L12342.301,3519.66 L12342.301,3511.325 L12341.469,3511.325 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12348.969,3496.324 L12358.97,3496.324 L12358.97,3504.658 L12348.969,3504.658 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12348.969,3511.326 L12358.97,3511.326 L12358.97,3519.66 L12348.969,3519.66 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12410.643,3504.658 L12410.643,3496.324 L12400.642,3496.324 L12400.642,3504.658 L12409.81,3504.658 L12410.643,3504.658 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12409.81,3511.325 L12400.642,3511.325 L12400.642,3519.66 L12410.643,3519.66 L12410.643,3511.325 L12409.81,3511.325 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12417.311,3496.324 L12427.312,3496.324 L12427.312,3504.658 L12417.311,3504.658 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12417.311,3511.326 L12427.312,3511.326 L12427.312,3519.66 L12417.311,3519.66 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12480.65,3337.972 L12480.65,3329.638 L12470.649,3329.638 L12470.649,3337.972 L12479.817,3337.972 L12480.65,3337.972 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12479.817,3344.64 L12470.649,3344.64 L12470.649,3352.974 L12480.65,3352.974 L12480.65,3344.64 L12479.817,3344.64 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12487.318,3329.638 L12497.319,3329.638 L12497.319,3337.972 L12487.318,3337.972 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12487.318,3344.64 L12497.319,3344.64 L12497.319,3352.974 L12487.318,3352.974 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12480.65,3384.645 L12480.65,3376.31 L12470.649,3376.31 L12470.649,3384.645 L12479.817,3384.645 L12480.65,3384.645 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12479.817,3391.312 L12470.649,3391.312 L12470.649,3399.646 L12480.65,3399.646 L12480.65,3391.312 L12479.817,3391.312 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12487.318,3376.31 L12497.319,3376.31 L12497.319,3384.644 L12487.318,3384.644 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12487.318,3391.312 L12497.319,3391.312 L12497.319,3399.646 L12487.318,3399.646 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12480.65,3431.317 L12480.65,3422.982 L12470.649,3422.982 L12470.649,3431.317 L12479.817,3431.317 L12480.65,3431.317 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12479.817,3437.984 L12470.649,3437.984 L12470.649,3446.318 L12480.65,3446.318 L12480.65,3437.984 L12479.817,3437.984 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12487.318,3422.982 L12497.319,3422.982 L12497.319,3431.316 L12487.318,3431.316 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12487.318,3437.984 L12497.319,3437.984 L12497.319,3446.318 L12487.318,3446.318 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12480.65,3477.989 L12480.65,3469.654 L12470.649,3469.654 L12470.649,3477.989 L12479.817,3477.989 L12480.65,3477.989 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12479.817,3484.656 L12470.649,3484.656 L12470.649,3492.99 L12480.65,3492.99 L12480.65,3484.656 L12479.817,3484.656 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12487.318,3469.654 L12497.319,3469.654 L12497.319,3477.989 L12487.318,3477.989 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12487.318,3484.656 L12497.319,3484.656 L12497.319,3492.99 L12487.318,3492.99 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12332.3,3337.972 L12428.979,3337.972 L12428.979,3357.974 L12332.3,3357.974 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12332.3,3377.977 L12428.979,3377.977 L12428.979,3397.979 L12332.3,3397.979 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12332.3,3417.981 L12428.979,3417.981 L12428.979,3437.984 L12332.3,3437.984 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12332.3,3457.986 L12428.979,3457.986 L12428.979,3477.989 L12332.3,3477.989 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12813.564,3333.805 L12805.23,3327.137 L12851.902,3285.465 L12970.249,3285.465 L12970.249,3322.137 L12893.574,3373.81 L12813.564,3333.805 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12991.826,3308.841 L12991.826,3286.298 L12976.113,3286.298 L12976.113,3291.82 L12970.249,3285.466 L12931.911,3327.137 L12916.91,3337.139 L12893.648,3507.083 L12928.729,3542.162 L13010.254,3542.162 L13010.254,3328.804 L12991.826,3308.841 z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12805.229,3327.137 L12931.911,3327.137 L12931.911,3542.163 L12805.229,3542.163 z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12854.402,3489.656 L12877.738,3489.656 L12877.738,3542.163 L12854.402,3542.163 z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12829.399,3504.658 L12829.399,3496.324 L12819.398,3496.324 L12819.398,3504.658 L12828.566,3504.658 L12829.399,3504.658 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12828.566,3511.325 L12819.398,3511.325 L12819.398,3519.66 L12829.399,3519.66 L12829.399,3511.325 L12828.566,3511.325 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12836.066,3496.324 L12846.067,3496.324 L12846.067,3504.658 L12836.066,3504.658 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12836.066,3511.326 L12846.067,3511.326 L12846.067,3519.66 L12836.066,3519.66 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12897.74,3504.658 L12897.74,3496.324 L12887.739,3496.324 L12887.739,3504.658 L12896.907,3504.658 L12897.74,3504.658 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12896.907,3511.325 L12887.739,3511.325 L12887.739,3519.66 L12897.74,3519.66 L12897.74,3511.325 L12896.907,3511.325 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12904.408,3496.324 L12914.409,3496.324 L12914.409,3504.658 L12904.408,3504.658 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12904.408,3511.326 L12914.409,3511.326 L12914.409,3519.66 L12904.408,3519.66 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12967.748,3337.972 L12967.748,3329.638 L12957.747,3329.638 L12957.747,3337.972 L12966.915,3337.972 L12967.748,3337.972 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12966.915,3344.64 L12957.747,3344.64 L12957.747,3352.974 L12967.748,3352.974 L12967.748,3344.64 L12966.915,3344.64 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12974.416,3329.638 L12984.417,3329.638 L12984.417,3337.972 L12974.416,3337.972 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12974.416,3344.64 L12984.417,3344.64 L12984.417,3352.974 L12974.416,3352.974 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12967.748,3384.645 L12967.748,3376.31 L12957.747,3376.31 L12957.747,3384.645 L12966.915,3384.645 L12967.748,3384.645 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12966.915,3391.312 L12957.747,3391.312 L12957.747,3399.646 L12967.748,3399.646 L12967.748,3391.312 L12966.915,3391.312 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12974.416,3376.31 L12984.417,3376.31 L12984.417,3384.644 L12974.416,3384.644 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12974.416,3391.312 L12984.417,3391.312 L12984.417,3399.646 L12974.416,3399.646 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12967.748,3431.317 L12967.748,3422.982 L12957.747,3422.982 L12957.747,3431.317 L12966.915,3431.317 L12967.748,3431.317 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12966.915,3437.984 L12957.747,3437.984 L12957.747,3446.318 L12967.748,3446.318 L12967.748,3437.984 L12966.915,3437.984 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12974.416,3422.982 L12984.417,3422.982 L12984.417,3431.316 L12974.416,3431.316 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12974.416,3437.984 L12984.417,3437.984 L12984.417,3446.318 L12974.416,3446.318 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12967.748,3477.989 L12967.748,3469.654 L12957.747,3469.654 L12957.747,3477.989 L12966.915,3477.989 L12967.748,3477.989 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12966.915,3484.656 L12957.747,3484.656 L12957.747,3492.99 L12967.748,3492.99 L12967.748,3484.656 L12966.915,3484.656 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12974.416,3469.654 L12984.417,3469.654 L12984.417,3477.989 L12974.416,3477.989 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12974.416,3484.656 L12984.417,3484.656 L12984.417,3492.99 L12974.416,3492.99 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12819.398,3337.972 L12916.076,3337.972 L12916.076,3357.974 L12819.398,3357.974 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12819.398,3377.977 L12916.076,3377.977 L12916.076,3397.979 L12819.398,3397.979 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12819.398,3417.981 L12916.076,3417.981 L12916.076,3437.984 L12819.398,3437.984 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12819.398,3457.986 L12916.076,3457.986 L12916.076,3477.989 L12819.398,3477.989 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13080.683,3333.805 L13072.349,3327.137 L13119.021,3285.465 L13237.367,3285.465 L13237.367,3322.137 L13160.692,3373.81 L13080.683,3333.805 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13258.944,3308.841 L13258.944,3286.298 L13243.231,3286.298 L13243.231,3291.82 L13237.367,3285.466 L13199.029,3327.137 L13184.028,3337.139 L13160.767,3507.083 L13195.847,3542.162 L13277.372,3542.162 L13277.372,3328.804 L13258.944,3308.841 z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13072.348,3327.137 L13199.029,3327.137 L13199.029,3542.163 L13072.348,3542.163 z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13121.521,3489.656 L13144.856,3489.656 L13144.856,3542.163 L13121.521,3542.163 z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13096.518,3504.658 L13096.518,3496.324 L13086.517,3496.324 L13086.517,3504.658 L13095.685,3504.658 L13096.518,3504.658 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13095.685,3511.325 L13086.517,3511.325 L13086.517,3519.66 L13096.518,3519.66 L13096.518,3511.325 L13095.685,3511.325 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13103.185,3496.324 L13113.186,3496.324 L13113.186,3504.658 L13103.185,3504.658 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13103.185,3511.326 L13113.186,3511.326 L13113.186,3519.66 L13103.185,3519.66 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13164.858,3504.658 L13164.858,3496.324 L13154.857,3496.324 L13154.857,3504.658 L13164.025,3504.658 L13164.858,3504.658 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13164.025,3511.325 L13154.857,3511.325 L13154.857,3519.66 L13164.858,3519.66 L13164.858,3511.325 L13164.025,3511.325 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13171.526,3496.324 L13181.527,3496.324 L13181.527,3504.658 L13171.526,3504.658 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13171.526,3511.326 L13181.527,3511.326 L13181.527,3519.66 L13171.526,3519.66 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13234.866,3337.972 L13234.866,3329.638 L13224.865,3329.638 L13224.865,3337.972 L13234.033,3337.972 L13234.866,3337.972 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13234.033,3344.64 L13224.865,3344.64 L13224.865,3352.974 L13234.866,3352.974 L13234.866,3344.64 L13234.033,3344.64 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13241.534,3329.638 L13251.535,3329.638 L13251.535,3337.972 L13241.534,3337.972 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13241.534,3344.64 L13251.535,3344.64 L13251.535,3352.974 L13241.534,3352.974 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13234.866,3384.645 L13234.866,3376.31 L13224.865,3376.31 L13224.865,3384.645 L13234.033,3384.645 L13234.866,3384.645 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13234.033,3391.312 L13224.865,3391.312 L13224.865,3399.646 L13234.866,3399.646 L13234.866,3391.312 L13234.033,3391.312 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13241.534,3376.31 L13251.535,3376.31 L13251.535,3384.644 L13241.534,3384.644 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13241.534,3391.312 L13251.535,3391.312 L13251.535,3399.646 L13241.534,3399.646 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13234.866,3431.317 L13234.866,3422.982 L13224.865,3422.982 L13224.865,3431.317 L13234.033,3431.317 L13234.866,3431.317 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13234.033,3437.984 L13224.865,3437.984 L13224.865,3446.318 L13234.866,3446.318 L13234.866,3437.984 L13234.033,3437.984 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13241.534,3422.982 L13251.535,3422.982 L13251.535,3431.316 L13241.534,3431.316 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13241.534,3437.984 L13251.535,3437.984 L13251.535,3446.318 L13241.534,3446.318 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13234.866,3477.989 L13234.866,3469.654 L13224.865,3469.654 L13224.865,3477.989 L13234.033,3477.989 L13234.866,3477.989 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13234.033,3484.656 L13224.865,3484.656 L13224.865,3492.99 L13234.866,3492.99 L13234.866,3484.656 L13234.033,3484.656 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13241.534,3469.654 L13251.535,3469.654 L13251.535,3477.989 L13241.534,3477.989 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13241.534,3484.656 L13251.535,3484.656 L13251.535,3492.99 L13241.534,3492.99 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13086.517,3337.972 L13183.194,3337.972 L13183.194,3357.974 L13086.517,3357.974 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13086.517,3377.977 L13183.194,3377.977 L13183.194,3397.979 L13086.517,3397.979 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13086.517,3417.981 L13183.194,3417.981 L13183.194,3437.984 L13086.517,3437.984 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13086.517,3457.986 L13183.194,3457.986 L13183.194,3477.989 L13086.517,3477.989 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11987.414,3541.33 L13361.682,3541.33 L13361.682,3543.748 L11987.414,3543.748 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12292.001,3445.845 L12294.418,3445.845 L12294.418,3541.33 L12292.001,3541.33 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12316.728,3458.013 C12316.882,3491.402 12293.391,3518.578 12293.391,3518.578 C12293.391,3518.578 12269.65,3491.62 12269.496,3458.231 C12269.343,3424.842 12292.833,3397.666 12292.833,3397.666 C12292.833,3397.666 12316.574,3424.624 12316.728,3458.013 z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12533.736,3445.845 L12536.154,3445.845 L12536.154,3541.33 L12533.736,3541.33 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12558.464,3458.013 C12558.617,3491.402 12535.127,3518.578 12535.127,3518.578 C12535.127,3518.578 12511.386,3491.62 12511.232,3458.231 C12511.078,3424.842 12534.569,3397.666 12534.569,3397.666 C12534.569,3397.666 12558.31,3424.624 12558.464,3458.013 z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13016,3445.845 L13018.417,3445.845 L13018.417,3541.33 L13016,3541.33 z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13040.727,3458.013 C13040.881,3491.402 13017.39,3518.578 13017.39,3518.578 C13017.39,3518.578 12993.649,3491.62 12993.495,3458.231 C12993.342,3424.842 13016.832,3397.666 13016.832,3397.666 C13016.832,3397.666 13040.572,3424.624 13040.727,3458.013 z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12743.442,3115.202 C12743.442,3120.91 12722.879,3125.537 12697.513,3125.537 C12672.146,3125.537 12651.583,3120.91 12651.583,3115.202 C12651.583,3109.495 12672.146,3104.868 12697.513,3104.868 C12722.879,3104.868 12743.442,3109.495 12743.442,3115.202 z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12749.486,2970.765 C12749.486,3000.137 12696.304,3083.172 12696.304,3083.172 C12696.304,3083.172 12643.122,3000.137 12643.122,2970.765 C12643.122,2941.394 12666.933,2917.583 12696.304,2917.583 C12725.676,2917.583 12749.486,2941.394 12749.486,2970.765 z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12726.521,2970.765 C12726.521,2987.454 12712.992,3000.982 12696.304,3000.982 C12679.615,3000.982 12666.087,2987.454 12666.087,2970.765 C12666.087,2954.077 12679.615,2940.548 12696.304,2940.548 C12712.992,2940.548 12726.521,2954.077 12726.521,2970.765 z",
    fill: "#F2F2F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacedonateImg6);
export default __webpack_public_path__ + "static/media/facedonate_img_6.bb98a0e4.svg";
export { ForwardRef as ReactComponent };